export const DDMMYYYY = 'DD/MM/YYYY'; // 10/8/2018
export const MMDDYYYY = 'MM/DD/YYYY'; // 08/10/2018
export const YYYYMMDD = 'YYYY-MM-DD'; // 2018-12-12
export const MMMMYYYY = 'MMMM YYYY'; // August 2018
export const ddddDoMMMM = 'dddd Do MMMM'; // Friday 10th August
export const DoMMMMYYYY = 'Do MMMM YYYY'; // 10th August 2018
export const DMMMYYYY = 'D MMM YYYY'; // 10 Aug 2018
export const ddddMMMMD = 'dddd, MMMM D'; // Friday, August 10
export const MMMMDYYYY = 'MMMM D, YYYY'; // August 10, 2018
